import React, { useEffect, useState } from 'react';

import { Dropdown } from 'react-bootstrap'

import logo from './../../assets/logo.png'
import Swal from './../../components/swal'

export default function Header({ history, callbackCompany }) {
    const swalOptions = {
        title: 'Deseja realmente sair do sistema?',
        icon: 'warning',
        buttons: {
            cancel: {
                text: 'Não',
                value: null,
                visible: true,
                className: "",
                closeModal: true
            },
            confirm: {
                text: 'Sim',
                value: true,
                visible: true,
                className: "bg-theme",
                closeModal: true
            }
        }
    }

    const resize = () => {
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
    }

    const toggleCollapsed = e => {
        e.preventDefault()
        document.querySelector('body').classList.toggle('aside-collapsed')
        resize()
    }

    const toggleAside = e => {
        e.preventDefault()
        document.querySelector('body').classList.toggle('aside-toggled')
    }

    const Logout = async (isConfirm, swal) => {
        if (isConfirm) {
            // await api.post('/logout')
            //          .then(() => {   
            //             localStorage.clear();
            //             history.push('/login')
            //          }).catch(error => {
            //             console.log(error)
            //          })  
        }
    }

    return (
        <header className="topnavbar-wrapper">
            <nav className="navbar topnavbar">
                <div className="navbar-header only-desktop">
                    <a className="navbar-brand" href="#/">
                        <div className="brand-logo">
                            <img className="img-fluid" src={logo} alt={process.env.REACT_APP_NAME} style={{ maxWidth: '60px', marginLeft: '-10px' }} />
                        </div>
                        <div className="brand-logo-collapsed">
                            <div style={{ backgroundColor: '#fff', borderRadius: '50%', width: '60px', height: "60px" }}>
                                <img className="img-fluid" src={logo} alt={process.env.REACT_APP_NAME} style={{ maxWidth: '52px', marginTop: '21px', marginLeft: "-1px" }} />
                            </div>

                        </div>
                    </a>

                </div>
                <div style={{ flexGrow: 1 }}>
                    <ul className="navbar-nav flex-row only-desktop">
                        <li className="nav-item">
                            <a href="/#" className="nav-link d-none d-md-block d-lg-block d-xl-block" onClick={toggleCollapsed}>
                                <em className="fa fa-bars"></em>
                            </a>
                            <a href="/#" className="nav-link sidebar-toggle d-md-none" onClick={toggleAside} style={{ marginLeft: "-180px" }}>
                                <em className="fa fa-bars"></em>
                            </a>
                        </li>
                    </ul>
                </div>

            </nav>
        </header>
    )
}